import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RakSmeServService } from 'src/raksme/services/raksme-services/rakservices.service';
import { Router } from '@angular/router';
import { LanguageService } from 'src/raksme/services/i18n/raksme.languageService';

@Component({
  selector: 'home-services',
  templateUrl: './raksme.homeServicesView.html',
  styleUrls: ['./raksme.homeServicesStyle.css']
})
export class HomeServicesComponent implements OnInit, OnDestroy {
  title = 'rak-sme';

  /** The services fetch failed. */
  public listFailed: boolean = false;

  /** Settled either way, so empty reads differently from loading. */
  public listLoaded: boolean = false;

  public pageData: object;
  public subscriptions: Subscription[] = [];
  public serviceDatas: any = [];
  public lang: string = '';
  public langUrl: string = '';

  @Input("pageContent")
  set setPagesData(_pageData: object){
    this.pageData = _pageData;
  }

  constructor(private rakService: RakSmeServService, private router: Router, private language: LanguageService){}

  ngOnInit(): void {

    // Exact segment match: includes('/ar') reports Arabic for English URLs
    // such as /business-directory/12/architects.
    this.lang = this.language.lang;
    this.langUrl = this.lang === 'ar' ? '/ar' : '';

    this.getServiceList();
  }

  /**
   * Extracted from ngOnInit so a failed fetch has something to retry. It had
   * no failure path: the homepage services carousel simply stayed empty.
   */
  getServiceList(): void {
    this.listFailed = false;
    this.listLoaded = false;
    const bodyData: object = {
      "url": 'all'
    }
    this.subscriptions.push(
      this.rakService.getServices(this.language.api('services'), bodyData).subscribe(
        res => {
          this.serviceDatas = res;
          this.listLoaded = true;
        },
        () => {
          this.listFailed = true;
          this.listLoaded = true;
        }
      )
    );
  }

  retryList(): void {
    this.getServiceList();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

}
